import {BotChat} from './BotChat';
export default BotChat;
